/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.Memberships {
    "use strict";

    import MembershipCommissionSettingEnum = Meevo.Model.MembershipCommissionSettingEnum;

    interface IMembershipCompensation {
        fee: Number,
        isPercent: boolean,
        membershipCommissionSetting: MembershipCommissionSettingEnum
    }

    export class CompensationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Membership> {
        
        public recurringCommision: any;
        public spiffCommision: any;
        public enrollmentCommision: any;

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template, params.isPrimarySection, params.handlesOwnCrud,
                params.baseEndpoint, params.sectionEndpoint,
                params.loggingService, params.dataService, params.identityService, params.noun,null,params.sectionSecurityKey);
        }
        
        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void { }
        
        public sectionModelRetrieved(): void {
            _.each(this.model['membershipCompensationSettings'], (el) => {
                switch (el['membershipCommissionSetting']) {
                    case MembershipCommissionSettingEnum.EnrollmentFee:
                        this.enrollmentCommision = el;
                        break;
                    case MembershipCommissionSettingEnum.RecurringFee:
                        this.recurringCommision = el;
                        break;
                    case MembershipCommissionSettingEnum.EmployeeSpiff:
                        this.spiffCommision = el;
                        break;
                }
            });

            // Create obj not in response from server
            if (!this.enrollmentCommision) {
                this.enrollmentCommision = {
                    fee: 0,
                    isPercent: true,
                    isEnabled: false,
                    membershipCommissionSetting: MembershipCommissionSettingEnum.EnrollmentFee
                };
                this.model['membershipCompensationSettings'].push(this.enrollmentCommision);
            }
            if (!this.recurringCommision) {
                this.recurringCommision = {
                    fee: 0,
                    isPercent: true,
                    isEnabled: false,
                    membershipCommissionSetting: MembershipCommissionSettingEnum.RecurringFee
                };
                this.model['membershipCompensationSettings'].push(this.recurringCommision);
            }
            if (!this.spiffCommision) {
                this.spiffCommision = {
                    fee: 0,
                    isPercent: true,
                    isEnabled: false,
                    membershipCommissionSetting: MembershipCommissionSettingEnum.EmployeeSpiff
                };
                this.model['membershipCompensationSettings'].push(this.spiffCommision);
            }
        }

        // Open popup
        commissionsOverride(list): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/compensation/commissionOverrideModal.template.html",
                clickOutsideToClose: false,
                controller: "meevo.components.compensation.CommissionsOverrideModalController",
                controllerAs: "vm",
                locals: {
                    employees: angular.copy(list)
                }
            }
            this.params.modalService.showCustom(options).then((response: any) => {
                if (response.status === true) {

                    // Set new array, without remove link to original array.
                    list.length = 0;
                    list.push.apply(list, response.employees);
                }
            });
        }
    }
}